import * as React from 'react';

const SvgInstagram = (props) => (
  <svg
    width={20}
    height={20}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      x={1.25}
      y={1.25}
      width={17.5}
      height={17.5}
      rx={6}
      fill='url(#instagram_svg__a)'
    />
    <rect
      x={1.25}
      y={1.25}
      width={17.5}
      height={17.5}
      rx={6}
      fill='url(#instagram_svg__b)'
    />
    <rect
      x={1.25}
      y={1.25}
      width={17.5}
      height={17.5}
      rx={6}
      fill='url(#instagram_svg__c)'
    />
    <path
      d='M14.375 6.563a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 13.125a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Zm0-1.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.75 9.75c0-2.1 0-3.15.409-3.952a3.75 3.75 0 0 1 1.639-1.64C6.6 3.75 7.65 3.75 9.75 3.75h.5c2.1 0 3.15 0 3.953.409a3.75 3.75 0 0 1 1.638 1.639c.409.802.409 1.852.409 3.952v.5c0 2.1 0 3.15-.409 3.953a3.75 3.75 0 0 1-1.638 1.638c-.803.409-1.853.409-3.953.409h-.5c-2.1 0-3.15 0-3.952-.409a3.75 3.75 0 0 1-1.64-1.638C3.75 13.4 3.75 12.35 3.75 10.25v-.5Zm6-4.75h.5c1.07 0 1.799.001 2.361.047.548.045.829.126 1.024.225a2.5 2.5 0 0 1 1.092 1.093c.1.196.181.476.226 1.024C15 7.95 15 8.679 15 9.75v.5c0 1.07-.001 1.799-.047 2.361-.045.548-.126.829-.226 1.024a2.5 2.5 0 0 1-1.092 1.092c-.195.1-.476.181-1.024.226-.562.046-1.29.047-2.361.047h-.5c-1.07 0-1.799-.001-2.361-.047-.548-.045-.828-.126-1.024-.226a2.5 2.5 0 0 1-1.093-1.092c-.1-.195-.18-.476-.225-1.024C5 12.05 5 11.321 5 10.25v-.5c0-1.07.001-1.799.047-2.361.045-.548.126-.828.225-1.024a2.5 2.5 0 0 1 1.093-1.093c.196-.1.476-.18 1.024-.225C7.95 5 8.679 5 9.75 5Z'
      fill='#fff'
    />
    <defs>
      <radialGradient
        id='instagram_svg__a'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='rotate(-55.376 17.447 .041) scale(15.9498)'
      >
        <stop stopColor='#B13589' />
        <stop offset={0.793} stopColor='#C62F94' />
        <stop offset={1} stopColor='#8A3AC8' />
      </radialGradient>
      <radialGradient
        id='instagram_svg__b'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='rotate(-65.136 18.604 4.306) scale(14.1214)'
      >
        <stop stopColor='#E0E8B7' />
        <stop offset={0.445} stopColor='#FB8A2E' />
        <stop offset={0.715} stopColor='#E2425C' />
        <stop offset={1} stopColor='#E2425C' stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id='instagram_svg__c'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='matrix(24.0625 -3.4375 .73525 5.14672 .313 1.875)'
      >
        <stop offset={0.157} stopColor='#406ADC' />
        <stop offset={0.468} stopColor='#6A45BE' />
        <stop offset={1} stopColor='#6A45BE' stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgInstagram;
